import { z } from "zod";
import {
    ReportSettingLogoOption,
    ReportSettingRowVisibility,
} from "@common/types/reports/report-settings";

export const LAYOUT_TEXT_FIELD_KEYS = [
    "header",
    "title",
    "subtitle",
    "subtitle2",
    "footer",
    "memo",
    "watermarkText",
] as const;

/** Upper bound for every layout text field, guarding unbounded `text` storage. */
export const LAYOUT_TEXT_FIELD_MAX_LENGTH = 1000;

const layoutTextFieldSchema = z.string().max(LAYOUT_TEXT_FIELD_MAX_LENGTH);

export const layoutValuesSchema = z.object({
    header: layoutTextFieldSchema,
    title: layoutTextFieldSchema,
    subtitle: layoutTextFieldSchema,
    subtitle2: layoutTextFieldSchema,
    footer: layoutTextFieldSchema,
    memo: layoutTextFieldSchema,
    watermarkText: layoutTextFieldSchema,
    logoOption: z.nativeEnum(ReportSettingLogoOption),
    rowVisibility: z.nativeEnum(ReportSettingRowVisibility),
});
export type LayoutValues = z.infer<typeof layoutValuesSchema>;

/** Every layout field key, derived from the schema so membership can't drift. */
export const LAYOUT_FIELD_KEYS = layoutValuesSchema.keyof().options;

export const layoutOwnValuesSchema = z.object({
    header: layoutTextFieldSchema.nullable(),
    title: layoutTextFieldSchema.nullable(),
    subtitle: layoutTextFieldSchema.nullable(),
    subtitle2: layoutTextFieldSchema.nullable(),
    footer: layoutTextFieldSchema.nullable(),
    memo: layoutTextFieldSchema.nullable(),
    watermarkText: layoutTextFieldSchema.nullable(),
    logoOption: z.nativeEnum(ReportSettingLogoOption).nullable(),
    rowVisibility: z.nativeEnum(ReportSettingRowVisibility).nullable(),
});
